import ko from 'knockout';

// TODO: This is a binding outside the vendors area so review
import '../../../../App/Bindings/enterTriggersElementClickBinding';
import template from './fileUploadSelecter.html';

export function FileUploadSelecter(params) {

  var self = this;
  var options = params.fileUploadSelectorOptions;

  var maximumUploadSize = ko.unwrap(options.maximumUploadSize);
  var maximumFilesUploads = ko.unwrap(options.maximumFilesUploads);
  var addFileUploadsCallback = options.addFileUploadsCallback;


  self.maximumUploadSize = maximumUploadSize;
  self.maximumFilesUploads = maximumFilesUploads || 5;

  self.addFileUploads = function (fileList) {
    addFileUploadsCallback(fileList);
  };
}

// The default export returns the component details object to register with KO
export default { viewModel: FileUploadSelecter, template: template };
